import { render } from "./sr-tbl-pagination.vue?vue&type=template&id=1dcd8e0d&scoped=true"
import script from "./sr-tbl-pagination.vue?vue&type=script&lang=js"
export * from "./sr-tbl-pagination.vue?vue&type=script&lang=js"

import "./sr-tbl-pagination.vue?vue&type=style&index=0&id=1dcd8e0d&scoped=true&lang=css"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcd8e0d"]])

export default __exports__